// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Mu-z","expressButtonContainerWithPayPal":"Nu-z","expressButton":"Ou-z","or":"Pu-z"};